import { render, staticRenderFns } from "./BequeathTile.vue?vue&type=template&id=23e4fae7&scoped=true"
import script from "./BequeathTile.vue?vue&type=script&lang=js"
export * from "./BequeathTile.vue?vue&type=script&lang=js"
import style0 from "./BequeathTile.vue?vue&type=style&index=0&id=23e4fae7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e4fae7",
  null
  
)

export default component.exports